function Term() {
  return (
    <div
      style={{
        margin: "20px auto",
        maxWidth: "900px",
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        padding: "24px 28px",
        fontFamily: "Segoe UI, sans-serif",
        lineHeight: 1.6,
        color: "#2d3436",
      }}
    >
      <h2 style={{ color: "#2d3436", marginBottom: "1rem" }}>
        📜 Terms and Conditions – Student Referral Program
      </h2>
      <p style={{ marginBottom: "20px", fontSize: "15px", color: "#555" }}>
        <strong>Pinnacle Civil Services</strong>
        <br />
        Effective Date: <time dateTime="2025-08-16">16 August 2025</time>
      </p>

      <ol style={{ paddingLeft: "1.2rem" }}>
        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Eligibility</strong>
          <br />
          The program is open only to registered students of{" "}
          <strong>Pinnacle Civil Services</strong>. Each student must have an
          active account with verified details.
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Referral Link</strong>
          <br />
          Each student will be provided with a unique referral link. Commission
          will only be generated when a purchase is made using this referral
          link.
          <br />
          <a
            href="https://referral.ssccglpinnacle.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#0b6bf2",
              textDecoration: "underline",
              fontWeight: "bold",
            }}
          >
            🔗 Refer & Earn Portal
          </a>
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Earnings & Commission</strong>
          <br />
          Commission will be earned on every successful purchase made through
          your referral link.
          <br />
          Commission percentage/amount may vary depending on the product.
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Payment Terms</strong>
          <br />
          Referral commissions are calculated weekly.
          <br />
          Payments will be transferred to the student’s bank account every{" "}
          <strong>Monday</strong>.
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Prohibited Activities</strong>
          <br />
          Students are not allowed to:
          <ul style={{ marginTop: "0.5rem", paddingLeft: "1.2rem" }}>
            <li>🚫 Share referral links on spammy or fake platforms.</li>
            <li>🚫 Mislead others with false offers or claims.</li>
            <li>🚫 Create fake accounts to generate commission.</li>
          </ul>
          <span style={{ color: "#d63031", fontSize: "14px" }}>
            Any such activity will lead to disqualification and cancellation of
            referral earnings.
          </span>
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Termination</strong>
          <br />
          Pinnacle reserves the right to suspend or terminate a student’s
          participation at any time in case of misuse or fraud.
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Modification of Terms</strong>
          <br />
          Pinnacle Civil Services reserves the right to modify these terms at
          any time. Updates will be communicated through the official website or
          student dashboard.
        </li>

        <li style={{ marginBottom: "1.2rem" }}>
          <strong>Contact</strong>
          <br />
          For queries regarding the referral program, contact:
          <br />
          📧{" "}
          <a
            href="mailto:support@ssccglpinnacle.com"
            style={{ color: "#0b6bf2", textDecoration: "underline" }}
          >
            support@ssccglpinnacle.com
          </a>
        </li>
      </ol>
    </div>
  );
}

export default Term;
